import Link from 'next/link'
import { memo } from 'react'
import { scrollToTabs } from '../../product-page.utils'

import './product-specifications.scss'

type Props = {
  title: string
  pathname: string
  linkText: string
  specifications: { name: string; value: string }[]
}

const ProductSpecifications = ({ title, pathname, linkText, specifications }: Props) => {
  const allSpecificationsLink = pathname + '?tab=specification'
  const maxSpecificationsToShow = 9

  return (
    <section className="product-specifications">
      <h2 className="h4">{title}</h2>
      <table data-testid="product-specifications-table">
        {specifications?.slice(0, maxSpecificationsToShow).map(({ name, value }, index) => (
          <tr key={index} data-testid={`product-specification-row-${index}`}>
            <td className="spec-name">{name}</td>
            <td className="spec-value">{value}</td>
          </tr>
        ))}
      </table>
      <Link
        onClick={scrollToTabs}
        data-testid="product-specifications-view-all-link"
        scroll={false}
        href={allSpecificationsLink}>
        {linkText}
      </Link>
    </section>
  )
}

export default memo(ProductSpecifications)
